import { UserRefundProgramModel } from '@/domain/models/refund/user-refund-program-list-model'

export interface UserRefundProgram {
  get(id: string): Promise<UserRefundProgram.Model>
}

export namespace UserRefundProgram {
  export type Model = UserRefundProgramModel
  export const Key = 'refund-program'
}
